
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/author/[username]",
      function () {
        return require("private-next-pages/blog/author/[username]/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/author/[username]"])
      });
    }
  